/**
 * Created by sorin on 8/10/2017.
 */
import jQuery from 'jquery';
import Promise from 'bluebird';
Promise.config({
  cancellation: true,
});

const jQueryReq = (options) => {
  return jQuery.ajax(options);
};

export default function jQueryAjaxRetry(options, ret = 3) {
  return new Promise((resolve, reject, onCancel) => {
    let jqXHR;
    const retryFunc = (retry) => {
      jqXHR = jQueryReq(options);
      jqXHR.fail(({statusText}) => {
        if (retry > 1 && statusText !== 'abort') { // i didn't find a documented best practice of detecting abort
          retryFunc(--retry);
        } else {
          reject(new Error(statusText));
        }
      }).then((...args) => {
        resolve(...args);
      });
    };
    onCancel(() => {
      if (jqXHR) {
        jqXHR.abort();
      }
    });
    retryFunc(ret);
  });
}
